import { useState, useEffect } from "react";
import { Bell, X } from "lucide-react";
import { isNativeApp } from "@/lib/native";
import { checkPushPermissionStatus, requestPushPermission } from "@/lib/nativePush";

const DISMISSED_KEY = "push_banner_dismissed";

export default function PushNotificationBanner({ user }) {
  const [visible, setVisible] = useState(false);
  const [permissionStatus, setPermissionStatus] = useState(null);

  useEffect(() => {
    if (!isNativeApp() || !user?.profile_complete || localStorage.getItem(DISMISSED_KEY)) return;

    checkPushPermissionStatus().then((status) => {
      setPermissionStatus(status);
      if (status !== "granted") setVisible(true);
    });
  }, [user?.profile_complete]);

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem(DISMISSED_KEY, "1");
  };

  const handleEnable = async () => {
    const granted = await requestPushPermission();
    if (granted) {
      setVisible(false);
    } else {
      dismiss();
    }
  };

  return (
    <div
      className="grid transition-[grid-template-rows] duration-300 ease-in-out"
      style={{ gridTemplateRows: visible ? "1fr" : "0fr" }}
    >
      <div className="overflow-hidden">
        <div className="bg-indigo-50 border-b border-indigo-200">
          <div className="flex items-center gap-3 px-4 py-2.5">
            <Bell className="w-4 h-4 text-indigo-600 flex-shrink-0" />
            <span className="text-sm font-medium text-indigo-800 flex-1">
              Enable push notifications to stay updated on your events.
            </span>
            <button
              onClick={handleEnable}
              className="text-xs font-semibold text-white bg-indigo-600 hover:bg-indigo-700 px-3 py-1 rounded-md transition-colors flex-shrink-0"
            >
              Enable
            </button>
            <button
              onClick={dismiss}
              className="text-indigo-400 hover:text-indigo-600 transition-colors flex-shrink-0"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
